import { connect } from 'react-redux'
import { change, formValueSelector } from 'redux-form'

import { FORM_NAME } from '../../../constants'

const mapStateToProps = (state, { fields }) => {
  const selector = formValueSelector(FORM_NAME)

  return {
    IDCardTypeID: fields.IDCardTypeID ? selector(state, fields.IDCardTypeID.FName) : undefined,
    IDCardIssuerTxt: fields.IDCardIssuerTxt ? selector(state, fields.IDCardIssuerTxt.FName) : undefined,
  }
}

const mapDispatchToProps = (dispatch) => ({
  deleteValidityDate: () => {
    dispatch(change(FORM_NAME, 'IDValidityDate', ''))
  },

  changeCitizenshipID: (value) => {
    dispatch(change(FORM_NAME, 'CitizenshipID', value))
  },

  changeResidentID: (value) => {
    dispatch(change(FORM_NAME, 'IND_Resident', value))
  },

  clearCellPhoneValidateCode: () => {
    dispatch(change(FORM_NAME, 'CellPhoneValidateCode', ''))
    dispatch(change(FORM_NAME, 'CodeVerifyPass', ''))
    dispatch(change(FORM_NAME, 'CodeVerifyClicked', ''))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)
